import { Component, OnInit } from '@angular/core';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from 'src/app/globals';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

  constructor(private http: HttpClient, private globals: Globals, private route: ActivatedRoute, public dialog: MatDialog) { }

  companyDomain: boolean = false
  users = null;
  emailAddress: string;
  name: string;
  tier: string;
  displayedColumns: string[] = ['EmailAddress', 'ItemsSent', 'Pause'];
  dataSource
  async ngOnInit(): Promise<void> {

    let param = new HttpParams();
    param = param = param.append('AuthToken', await this.globals.getAuthToken());
    param = param.append('UserName', this.globals.getSystemUserName());
    this.http.get<any>(this.globals.getApiUrl() + 'api/getSPMailCompanyInfo.php', { params: param }).subscribe({
      next: companyData => {
        this.http.get<any>(this.globals.getApiUrl() + 'api/getSPMailCompanyDomainUserInfo.php', { params: param }).subscribe({
          next: data => {
            // data = [{
            //   Domain: 'company-123.com',
            //   TLSCheckEmailUserList: [{
            //     UserName: 'you',
            //     UserEmail: 'you@company123.com',
            //     SentEmailCount: 12,
            //   }, {
            //     UserName: 'us',
            //     UserEmail: 'us@company123.com',
            //     SentEmailCount: 12,
            //   },],
            //   EncryptedEmailUserList: [{
            //     UserName: 'me',
            //     UserEmail: 'me@company123.com',
            //     SentEmailCount: 12,
            //     PausedCount: 3,
            //     IsPausedFlag: 'N',
            //   }, {
            //     UserName: 'you',
            //     UserEmail: 'you@company123.com',
            //     SentEmailCount: 12,
            //     PausedCount: 4,
            //     IsPausedFlag: 'N',
            //   }, {
            //     UserName: 'us',
            //     UserEmail: 'us@company123.com',
            //     SentEmailCount: 12,
            //     PausedCount: 1,
            //     IsPausedFlag: 'N',
            //   },],
            //   DocSigningEmailUserList: [{
            //     UserName: 'me',
            //     UserEmail: 'me@company123.com',
            //     SentEmailCount: 12,
            //     PausedCount: 3,
            //     IsPausedFlag: 'N',
            //   }, {
            //     UserName: 'sash',
            //     UserEmail: 'sash@company123.com',
            //     SentEmailCount: 12,
            //     PausedCount: 1,
            //     IsPausedFlag: 'Y',
            //   }]
            // }]
            //companyData.InitialTier = 126
            this.tier = companyData.InitialTier;
            if (companyData.InitialTier == 120) {
              this.users = data[0].EncryptedEmailUserList
            } if (companyData.InitialTier == 122) {
              this.users = data[0].DocSigningEmailUserList
            } if (companyData.InitialTier == 124) {
              this.users = Object.values([...data[0].EncryptedEmailUserList, ...data[0].DocSigningEmailUserList].reduce((a, v) => {
                if (a[v.UserName]) {
                  a[v.UserName].SentEmailCount += v.SentEmailCount
                  if (a[v.UserName].PausedCount < v.PausedCount){a[v.UserName].PausedCount = v.PausedCount} 
                  if (a[v.UserName].IsPausedFlag == 'N' || v.IsPausedFlag == 'N') { a[v.UserName].IsPausedFlag = 'N' }
                }
                else a[v.UserName] = { ...v }
                return a;
              }, {}));
            }
            
            
            
            
            
            
            if (companyData.InitialTier == 126) {
              let tempUsersList =[]
              for(let user of data[0].TLSCheckEmailUserList){
                user.TLS="Y"
                user.IsPausedFlag = "N"
                tempUsersList.push(user);
              }
              for(let user of data[0].EncryptedEmailUserList){
                if(tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)]){
                  tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].EIsPausedFlag = user.IsPausedFlag;
                  tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].IsPausedFlag = "N";
                  tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].PausedCount  = user.PausedCount;
                  tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].E  = "Y";
                } else{
                  user.TLS="N"
                  user.E="Y"
                  user.EIsPausedFlag = user.IsPausedFlag
                  user.IsPausedFlag = "N"
                  tempUsersList.push(user);
                }
              }
              for(let user of data[0].DocSigningEmailUserList){
                if(tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)]){
                  tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].DIsPausedFlag = user.IsPausedFlag;
                  tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].IsPausedFlag = "N";
                  if(tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].PausedCount < user.PausedCount){
                    tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].PausedCount  = user.PausedCount;                  
                  }
                    tempUsersList[tempUsersList.findIndex(({ UserName }) => UserName === user.UserName)].D  = "Y";
                } else{
                  user.TLS="N"
                  user.E="N"
                  user.D="Y"
                  user.DIsPausedFlag = user.IsPausedFlag
                  user.EIsPausedFlag = "N"
                  user.IsPausedFlag = "N"
                  tempUsersList.push(user);
                }
              }
              for(let user of tempUsersList){
                if(!user.TLS){user.TLS = "N"}
                if(!user.E){user.E = "N"; user.EIsPausedFlag = "N"}
                if(!user.D){user.D = "N"; user.DIsPausedFlag = "N"}
                if((user.E == "N" && user.DIsPausedFlag=="Y")||(user.D == "N" && user.EIsPausedFlag=="Y")){
                  user.IsPausedFlag="Y"
                }
              }
              this.users=tempUsersList;
              console.log(this.users)
            }

            this.dataSource = this.users;
          },
          error: error => { console.error('There was an error!'); }
        })
      },
      error: error => { console.error('There was an error!'); }
    });


    /*this.http.get<any>(this.globals.getApiUrl()+'api/getSPMailCompanyInfo.php', {params:param}).subscribe({next: data => 
    {
      if(data.DomainList==""){this.companyDomain=false}
      else{this.companyDomain=true}
    },
    error: error => 
      {console.error('There was an error!');}
    });*/
  }
  async deleteUser(userDel: string, userName: string) {
    let tempText;
    if(this.tier=="120"){
      tempText = [
        'You are about to suspend ' + userName + "'s account. This account will remain active but will no longer be billed for.",
        'If they send a new encrypted email, their account will automatically be unsuspended.'
      ]
    } else if(this.tier=="122"){
      tempText = [
        'You are about to suspend ' + userName + "'s account. This account will remain active but will no longer be billed for.",
        'If they send a new document signing request, their account will automatically be unsuspended.'
      ]
    } else if(this.tier=="124"){
      tempText = [
        'You are about to suspend ' + userName + "'s account. This account will remain active but will no longer be billed for.",
        'If they send a new encrypted email or document signing request, their account will automatically be unsuspended.'
      ]
    } else if(this.tier=="126"){
      tempText = [
        'You are about to downgrade ' + userName + "'s account.",
        'If they send a new encrypted email or document signing request, their account will automatically be upgraded accordingly.'
      ]
    }
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      autoFocus: false,
      maxWidth:700,
      data: {
        text: tempText
      },
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result == true) {
        
        this.users[this.users.findIndex(({ UserName }) => UserName === userDel)].IsPausedFlag = 'Y';
        this.users[this.users.findIndex(({ UserName }) => UserName === userDel)].EIsPausedFlag = 'Y';
        this.users[this.users.findIndex(({ UserName }) => UserName === userDel)].DIsPausedFlag = 'Y';
        let postForm = new FormData;
        postForm.append('AuthToken', await this.globals.getAuthToken());
        postForm.append('UserName', this.globals.getSystemUserName());
        postForm.append('PauseUserName', userDel);
        this.http.post<any>(this.globals.getApiUrl() + 'api/pauseSPMailCompanyDomainUser.php', postForm).subscribe({
          next: data => {
            this.users[this.users.findIndex(({ UserName }) => UserName === userDel)].IsPausedFlag = 'Y';
            this.users[this.users.findIndex(({ UserName }) => UserName === userDel)].EIsPausedFlag = 'Y';
            this.users[this.users.findIndex(({ UserName }) => UserName === userDel)].DIsPausedFlag = 'Y';
          },
          error: error => {
            console.log(this.users)

          }
        });
      }
    });
  }
}
